import { useSavedSearchCounts } from '@aibees/elephant/hooks/saved-search/use-saved-search-counts';
import { useAdvanceTableDataFiltersContext } from '@aibees/shared/features';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { CardVisibilityTabs } from '../card-visibility-tabs';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { SavedCardTableProps as Props } from './types';

const SavedVisibilityTabs = memo(function SavedVisibilityTabs() {
  const { filters } = useAdvanceTableDataFiltersContext();
  const { byScope } = useSavedSearchCounts(filters);

  // For saved searches the backend reads `visibility` as an ownership filter —
  // PRIVATE is "created by me", INTERNAL is "created by a teammate" — so these
  // counts line up with the rows each tab shows, and Mine + Team is the total.
  // See docs/saved-search-presets.md.
  const counts = useMemo(
    () =>
      byScope ? { private: byScope.mine, internal: byScope.team } : undefined,
    [byScope]
  );

  return <CardVisibilityTabs counts={counts} />;
});

const renderPrepend = () => <SavedVisibilityTabs />;
const finalConfig = { ...config, renderTablePrependStable: renderPrepend };

export const SavedCardTable = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('SavedCardTable', className)}
      sx={SX.root}
      config={finalConfig}
    />
  );
});

SavedCardTable.displayName = 'SavedCardTable';
